import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type StartUploadTransferJobMutationVariables = Types.Exact<{
  input: Types.StartUploadTransferJobInput;
}>;


export type StartUploadTransferJobMutation = { __typename?: 'Mutation', startUploadTransferJob: boolean };


export const StartUploadTransferJob = /*#__PURE__*/ gql`
    mutation StartUploadTransferJob($input: StartUploadTransferJobInput!) {
  startUploadTransferJob(input: $input)
}
    ` as unknown as DocumentNode<StartUploadTransferJobMutation, StartUploadTransferJobMutationVariables>;

          

          export const useStartUploadTransferJobMutation = (options?:MutationHookOptions<StartUploadTransferJobMutation, StartUploadTransferJobMutationVariables>) => useMutation(StartUploadTransferJob, options);
          

          export type StartUploadTransferJobMutationOptions = MutationHookOptions<StartUploadTransferJobMutation, StartUploadTransferJobMutationVariables>;

          

          export type StartUploadTransferJobMutationResult = ReturnType<typeof useStartUploadTransferJobMutation>[1];

          
